export const settings = {
  vitalSignDisplayAndOrder: { ko: 'Vital Sign 표시 여부 및 순서', en: 'Vital Sign Display and Order', fr: '' },
  vitalSignDisplayAndOrderDesc: {
    ko: '환자 상세 페이지에서 표시되는 Vital Sign의 표시 여부 및 순서를 설정할 수 있습니다. 표시 여부는 체크박스로, 순서는 버튼으로 설정하세요.',
    en: 'You can configure the visibility and order of Vital Signs displayed on the patient detail page. Use checkboxes to set visibility and buttons to adjust the order.',
    fr: '',
  },
  chartSetting: { ko: '차트 설정', en: 'Chart Settings', fr: '' },
  chartSettingDesc: {
    ko: '환자 상세 페이지에서 표시되는 Vital Sign 차트의 y축 최대/최소값을 설정할 수 있습니다.',
    en: 'You can set the maximum and minimum values of the Y-axis for the Vital Sign charts displayed on the patient detail page.',
    fr: '',
  },
  customChartSetting: { ko: '사용자 정의 차트 설정', en: 'Custom Chart Settings', fr: '' },
  customChartSettingDesc: {
    ko: '환자 상세 페이지에서 표시되는 사용자 정의 차트를 설정합니다. 좌우측 y축에 각각 4개까지 (총 8개) Vital Sign을 표시할 수 있습니다.',
    en: 'You can configure custom charts displayed on the patient detail page. Up to four Vital Signs can be shown on each Y-axis (a total of eight).',
    fr: '',
  },
  vitalSignSetting: { ko: 'Vital Sign 설정', en: 'Vital Sign Settings', fr: '' },
  vitalSignAdd: { ko: 'Vital Sign 추가', en: 'Add Vital Sign', fr: '' },
  usageStatus: { ko: '사용 여부', en: 'Enable / Disable', fr: '' },
  selectVitalSign: { en: 'Select Vital Sign', ko: 'Vital Sign 선택' },
  updateSuccess: { en: 'The settings have been saved successfully.', ko: '설정이 성공적으로 저장되었습니다.' },
  updateFail: { en: 'Failed to save the settings.', ko: '설정 저장에 실패했습니다.' },
};
